export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ChangePasswordDialog.json?hash=7f31d3f3f30bd55361c69b5c2a501578";